import { Component, OnInit, OnDestroy, Input, ChangeDetectorRef, ViewRef, ChangeDetectionStrategy } from '@angular/core';
import { FieldType } from "@ngx-formly/core";
import { AppStateService } from "src/app/core-module/services/app-state.service";
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';

import { AloAocStateService } from "../core-module/services/state/alo-aoc-state.service";
import { FeatureDataStateService } from "../core-module/services/state/feature-data-state.service";
import { FeatureDefaultsStateService } from "../core-module/services/state/feature-defaults-state.service";
import { FeatureUtilsService } from "../core-module/services/state/feature-utils.service";
@Component({
  standalone: false,
  selector: "app-codedmains",
  templateUrl: "./codedmains.component.html",
  styleUrls: ["./codedmains.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CodedmainsComponent
  extends FieldType
  implements OnInit, OnDestroy
{
  @Input() field;
  codedmainsDefaultColor;
  featureVersion: LegacyAny;
  column: LegacyAny;
  properties: LegacyAny;
  ngModelval: LegacyAny = [];
  inputError: LegacyAny = {};
  codedmainsCreateFile: boolean;
  quickConfigvalue: boolean;
  quickConfigCustomCSS: string;
  quickConfigCustomCSSFallbackScene: string;
  setQuickConfig: string;
  isCodedMainsEnabled: LegacyAny;
  valueSet = [];
  valueSetSecond = [];
  FadeTime: LegacyAny;
  FadeTimeMin: LegacyAny;
  FadeTimeMax: LegacyAny;
  FastFadeTime: LegacyAny;
  FastFadeTimeMin: LegacyAny;
  FastFadeTimeMax: LegacyAny;
  isFastFadeTimeEnabled: boolean;
  isLastDefinedDimLevelEnabled: boolean;
  FallbackDetectionTime: LegacyAny;
  FallbackDetectionTimeMin: LegacyAny;
  FallbackDetectionTimeMax: LegacyAny;
  FallbackDetectionTimeValue: LegacyAny;
  FallbackDetectionTimeOption: { floor: LegacyAny; ceil: LegacyAny };
  PowerOnLevel: LegacyAny;
  PowerOnLevelMin: LegacyAny;
  PowerOnLevelMax: LegacyAny;
  PowerOnLevelValue: LegacyAny;
  PowerOnLevelOption: { floor: LegacyAny; ceil: LegacyAny };
  Scene1: LegacyAny;
  Scene1Min: LegacyAny;
  Scene1Max: LegacyAny;
  Scene1Value: LegacyAny;
  Scene2: LegacyAny;
  Scene2Min: LegacyAny;
  Scene2Max: LegacyAny;
  Scene2Value: LegacyAny;
  Scene5: LegacyAny;
  Scene5Min: LegacyAny;
  Scene5Max: LegacyAny;
  Scene5Value: LegacyAny;
  Scene6: LegacyAny;
  Scene6Min: LegacyAny;
  Scene6Max: LegacyAny;
  Scene6Value: LegacyAny;
  Scene9: LegacyAny;
  Scene9Min: LegacyAny;
  Scene9Max: LegacyAny;
  Scene9Value: LegacyAny;
  Scene3: LegacyAny;
  Scene3Min: LegacyAny;
  Scene3Max: LegacyAny;
  Scene3Value: LegacyAny;
  Scene7: LegacyAny;
  Scene7Min: LegacyAny;
  Scene7Max: LegacyAny;
  Scene7Value: LegacyAny;
  Scene10: LegacyAny;
  fadeTimeDynamicVal: LegacyAny;
  fastfadeTimeDynamicVal: LegacyAny;
  Scene10Min: LegacyAny;
  Scene10Max: LegacyAny;
  Scene10Value: LegacyAny;
  Scene11: LegacyAny;
  Scene11Min: LegacyAny;
  Scene11Max: LegacyAny;
  Scene11Value: LegacyAny;
  Scene4: LegacyAny;
  Scene4Min: LegacyAny;
  Scene4Max: LegacyAny;
  Scene4Value: LegacyAny;
  Scene8: LegacyAny;
  Scene8Min: LegacyAny;
  Scene8Max: LegacyAny;
  Scene8Value: LegacyAny;
  Scene12: LegacyAny;
  Scene12Min: LegacyAny;
  Scene12Max: LegacyAny;
  Scene12Value: LegacyAny;
  FallbackScene: LegacyAny;
  FallbackSceneMin: LegacyAny;
  FallbackSceneMax: LegacyAny;
  FallbackSceneValue: LegacyAny;
  ischeckboxChecked: boolean;
  fadeTimeDataset = {
    "0": "0",
    "1": "0.7",
    "2": "1.0",
    "3": "1.4",
    "4": "2.0",
    "5": "2.8",
    "6": "4.0",
    "7": "5.7",
    "8": "8.0",
    "9": "11.3",
    "10": "16.0",
    "11": "22.6",
    "12": "32.0",
    "13": "45.3",
    "14": "64.0",
    "15": "90.5",
  };
  pathVal:string;
  fastfadeTimeDataset = {
    "0": "<25",
    "1": "25",
    "2": "50",
    "3": "75",
    "4": "100",
    "5": "125",
    "6": "150",
    "7": "175",
    "8": "200",
    "9": "225",
    "10": "250",
    "11": "275",
    "12": "300",
    "13": "325",
    "14": "350",
    "15": "375",
    "16": "400",
    "17": "425",
    "18": "450",
    "19": "475",
    "20": "500",
    "21": "525",
    "22": "550",
    "23": "575",
    "24": "600",
    "25": "625",
    "26": "650",
    "27": "675",
  };

  FallbackDetectionTimeDisplayValue: LegacyAny;
  PowerOnLevelDisplayValue: LegacyAny;

  private fallbackDetectionTimeInputSubject = new Subject<string>();
  private powerOnLevelInputSubject = new Subject<string>();
  // Backward-compatible facade for legacy specs still referencing `component['service']`.
  service: LegacyAny;

  constructor(
    private ref: ChangeDetectorRef, private appState: AppStateService,
    private utils: FeatureUtilsService,
    private featureDefaults: FeatureDefaultsStateService,
    private featureData: FeatureDataStateService,
    private aloAoc: AloAocStateService
  ) {
    super();
    this.service = {
      getImageUrl: (host: string) => this.utils.getImageUrl(host),
      getcodedmainsDefaultValue: this.featureDefaults.getcodedmainsDefaultValue,
      getcodedmainsDefault: this.featureDefaults.getcodedmainsDefault,
      getcodedmainsData: this.featureData.getcodedmainsData,
      getquickConfig: this.aloAoc.getquickConfig,
      sendcodedmainsdata: (data: LegacyAny) => this.featureData.sendcodedmainsdata(data),
      codedmainsEditedVal: (data: LegacyAny) => this.featureData.codedmainsEditedVal(data),
      codedmainsInputError: (data: LegacyAny) => this.featureData.codedmainsInputError(data),
      setcodedmainsDefaultColor: (data: LegacyAny) => this.featureDefaults.setcodedmainsDefaultColor(data),
    };
  }
  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    return !(charCode > 31 && (charCode < 48 || charCode > 57));
  }
  ngOnInit() {
    this.pathVal = this.service.getImageUrl(window.location.hostname);
    this.service.getcodedmainsDefaultValue.subscribe((response) => {
      if (response == "valid") {
        this.codedmainsDefaultColor = true;
        this.resetDefaultcodedmains();
      }
    });
    this.service.getcodedmainsDefault.subscribe((response) => {
      if (response) {
        this.codedmainsDefaultColor = true;
        this.resetDefaultcodedmains();
      }
    });
    this.service.getcodedmainsData.subscribe((data) => {
      if (data) {
        this.ngModelval = data;
        this.ngModelval["FadeTime"] = data["FadeTime"];
        this.ngModelval["FastFadeTime"] = data["FastFadeTime"];
        this.ngModelval["FallbackDetectionTime"] =
          data["FallbackDetectionTime"];
        this.ngModelval["PowerOnLevel"] = data["PowerOnLevel"];
        this.ngModelval["FallbackScene"] = data["FallbackScene"];
        this.ngModelval["Scene1"] = data["Scene1"];
        this.ngModelval["Scene2"] = data["Scene2"];
        this.ngModelval["Scene3"] = data["Scene3"];
        this.ngModelval["Scene4"] = data["Scene4"];
        this.ngModelval["Scene5"] = data["Scene5"];
        this.ngModelval["Scene6"] = data["Scene6"];
        this.ngModelval["Scene7"] = data["Scene7"];
        this.ngModelval["Scene8"] = data["Scene8"];
        this.ngModelval["Scene9"] = data["Scene9"];
        this.ngModelval["Scene10"] = data["Scene10"];
        this.ngModelval["Scene11"] = data["Scene11"];
        this.ngModelval["Scene12"] = data["Scene12"];
        this.checkdfault();
        this.validateSceneValues();
        this.checkInvalidValues();
      }
    });
    this.ngModelval["ischeckboxChecked"] = this.ischeckboxChecked = false;

    // Guard: If schema not loaded, initialize with safe defaults and return
    if (!this.field || !this.field.properties || !this.field.oneOf) {
      this.FallbackDetectionTimeOption = { floor: 0, ceil: 100 };
      this.PowerOnLevelOption = { floor: 0, ceil: 100 };
      return;
    }

    this.featureVersion = this.field.featureVersion;
    this.column = this.field.requiredProperties;
    this.properties = this.field.properties;
    this.fadeFastFadeOptions();
    this.FallbackScene = this.properties.FallbackScene;
    this.FallbackSceneMin =
      this.field.oneOf[0].properties.FallbackScene.minimum;
    this.FallbackSceneMax =
      this.field.oneOf[0].properties.FallbackScene.maximum;
    this.ngModelval["FallbackScene"] = this.FallbackSceneValue =
      this.FallbackScene.default;
    this.FallbackDetectionTime = this.properties.FallbackDetectionTime;
    this.FallbackDetectionTimeMin = this.FallbackDetectionTime.minimum;
    this.FallbackDetectionTimeMax = this.FallbackDetectionTime.maximum;
    this.ngModelval["FallbackDetectionTime"] = this.FallbackDetectionTimeValue =
      this.FallbackDetectionTime.default;
    this.FallbackDetectionTimeOption = {
      floor: this.FallbackDetectionTimeMin,
      ceil: this.FallbackDetectionTimeMax,
    };
    this.PowerOnLevel = this.properties.PowerOnLevel;
    this.PowerOnLevelMin = this.PowerOnLevel.minimum;
    this.PowerOnLevelMax = this.PowerOnLevel.maximum;
    this.ngModelval["PowerOnLevel"] = this.PowerOnLevelValue =
      this.PowerOnLevel.default;
    this.PowerOnLevelOption = {
      floor: this.PowerOnLevelMin,
      ceil: this.PowerOnLevelMax,
    };
    this.Scene12 = this.properties.Scene12;
    this.Scene12Min = this.Scene12.minimum;
    this.Scene12Max = this.Scene12.maximum;
    this.ngModelval["Scene12"] = this.Scene12Value = this.Scene12.default;
    this.Scene4 = this.properties.Scene4;
    this.Scene4Min = this.Scene4.minimum;
    this.Scene4Max = this.Scene4.maximum;
    this.ngModelval["Scene4"] = this.Scene4Value = this.Scene4.default;
    this.Scene1 = this.properties.Scene1;
    this.Scene1Min = this.Scene1.minimum;
    this.Scene1Max = this.Scene1.maximum;
    this.ngModelval["Scene1"] = this.Scene1Value = this.Scene1.default;
    this.Scene11 = this.properties.Scene11;
    this.Scene11Min = this.Scene11.minimum;
    this.Scene11Max = this.Scene11.maximum;
    this.ngModelval["Scene11"] = this.Scene11Value = this.Scene11.default;
    this.Scene2 = this.properties.Scene2;
    this.Scene2Min = this.Scene2.minimum;
    this.Scene2Max = this.Scene2.maximum;
    this.ngModelval["Scene2"] = this.Scene2Value = this.Scene2.default;
    this.Scene5 = this.properties.Scene5;
    this.Scene5Min = this.Scene5.minimum;
    this.Scene5Max = this.Scene5.maximum;
    this.ngModelval["Scene5"] = this.Scene5Value = this.Scene5.default;
    this.Scene6 = this.properties.Scene6;
    this.Scene6Min = this.Scene6.minimum;
    this.Scene6Max = this.Scene6.maximum;
    this.ngModelval["Scene6"] = this.Scene6Value = this.Scene6.default;
    this.Scene9 = this.properties.Scene9;
    this.Scene9Min = this.Scene9.minimum;
    this.Scene9Max = this.Scene9.maximum;
    this.ngModelval["Scene9"] = this.Scene9Value = this.Scene9.default;
    this.Scene3 = this.properties.Scene3;
    this.Scene3Min = this.Scene3.minimum;
    this.Scene3Max = this.Scene3.maximum;
    this.ngModelval["Scene3"] = this.Scene3Value = this.Scene3.default;
    this.Scene7 = this.properties.Scene7;
    this.Scene7Min = this.Scene7.minimum;
    this.Scene7Max = this.Scene7.maximum;
    this.ngModelval["Scene7"] = this.Scene7Value = this.Scene7.default;
    this.Scene10 = this.properties.Scene10;
    this.Scene10Min = this.Scene10.minimum;
    this.Scene10Max = this.Scene10.maximum;
    this.ngModelval["Scene10"] = this.Scene10Value = this.Scene10.default;
    this.Scene8 = this.properties.Scene8;
    this.Scene8Min = this.Scene8.minimum;
    this.Scene8Max = this.Scene8.maximum;
    this.ngModelval["Scene8"] = this.Scene8Value = this.Scene8.default;
    this.service.getquickConfig.subscribe((data) => {
      if (data === "quickConfig") {
        this.quickConfigvalue = true;
        this.quickConfigCustomCSS = "quick-custom-inputbox textBoxUnit";
        this.quickConfigCustomCSSFallbackScene = "quick-custom-inputbox";
        this.setQuickConfig = "quickConfig";
      } else if (data === "standard") {
        this.quickConfigvalue = false;
        this.quickConfigCustomCSS = "custom-inputbox";
        this.quickConfigCustomCSSFallbackScene = "custom-inputbox";
        this.setQuickConfig = "standard";
      }
      setTimeout(() => {
        if (this.ref && !(this.ref as ViewRef).destroyed) {
          this.ref.detectChanges();
        }
      });
    });

    const unSelectedFeat = this.appState.getUnSelectedFeatConfig();
    let isConfigEdited = false;
    let featIndex: number = 0;
    if (unSelectedFeat != null) {
      unSelectedFeat.forEach((element) => {
        if (element != null && element["featureName"] != null && element["featureName"].toString().toUpperCase() === "CODEDMAINS") {
          isConfigEdited = true;
          const codedMains: LegacyAny = element["featureParameters"][0];
          this.codedMainsLoadValues(codedMains);
          unSelectedFeat.splice(featIndex, 1);
          this.appState.setUnSelectedFeatConfig(unSelectedFeat);
        } else {
          featIndex++;
        }
      });
    }

    /////

    if (!isConfigEdited) {
      // Use centralized method to get feature data
      // This automatically prioritizes SaveSetData over ConfigurationData
      const codedMainsData = this.appState.getFeatureData('CodedMains') ||
                             this.appState.getFeatureData('codedmains') ||
                             this.appState.getFeatureData('CODEDMAINS');
      if (codedMainsData) {
        this.codedMainsLoadValues(codedMainsData);
      }
    }

    this.sendcodedmainsdata();

    this.FallbackDetectionTimeDisplayValue = this.FallbackDetectionTimeValue;
    this.PowerOnLevelDisplayValue = this.PowerOnLevelValue;

    this.fallbackDetectionTimeInputSubject.pipe(
      debounceTime(50),
      distinctUntilChanged()
    ).subscribe(value => {
      this.validateAndUpdateField(value, 'FallbackDetectionTime');
    });

    this.powerOnLevelInputSubject.pipe(
      debounceTime(50),
      distinctUntilChanged()
    ).subscribe(value => {
      this.validateAndUpdateField(value, 'PowerOnLevel');
    });

  }

  sendcodedmainsdata(){
    this.service.sendcodedmainsdata(this.ngModelval);
    this.setConfigurationData(this.ngModelval, "CodedMains");
  }

  setConfigurationData(value, keyVal) {
    if(value != null){
      // Use centralized method to save feature data
      // This automatically saves to both ConfigurationData and SaveSetData
      const codedMainsObj = Object.assign({}, value);
      this.appState.setFeatureData(keyVal, codedMainsObj);
    }
  }


  fadeFastFadeOptions() {
    this.valueSet = [];
    this.valueSetSecond = [];
    if (this.properties.FadeTime) {
      this.FadeTime = this.properties.FadeTime;
      this.ngModelval["FadeTime"] = this.FadeTime.default;
      this.fadeTimeDynamicVal = this.fadeTimeDataset[this.FadeTime.default];
      this.FadeTimeMin = this.properties.FadeTime.minimum;
      this.FadeTimeMax = this.properties.FadeTime.maximum;
      for (let i = this.FadeTimeMin; i <= this.FadeTimeMax; i++) {
        this.valueSet.push(i);
      }
    }
    if (this.properties.FastFadeTime) {
      this.FastFadeTime = this.properties.FastFadeTime;
      const fastFadeTimeDefault = this.FastFadeTime.default !== undefined ? this.FastFadeTime.default : this.FastFadeTime.const;
      this.ngModelval["FastFadeTime"] = fastFadeTimeDefault;
      this.fastfadeTimeDynamicVal =
        this.fastfadeTimeDataset[fastFadeTimeDefault];
      this.FastFadeTimeMin = this.properties.FastFadeTime.minimum;
      this.FastFadeTimeMax = this.properties.FastFadeTime.maximum;
      this.FadeTime = this.properties.FadeTime;
      if (this.FadeTime.default != 0) {
        this.isFastFadeTimeEnabled = true;
      } else {
        this.isFastFadeTimeEnabled = false;
      }
      for (let i = this.FastFadeTimeMin; i <= this.FastFadeTimeMax; i++) {
        this.valueSetSecond.push(i);
      }
    }
  }
  codedMainsLoadValues(CodedMains: LegacyAny) {
    const CodedMainsObj = CodedMains;
    const keys = Object.keys(CodedMainsObj);
    const values = Object.values(CodedMainsObj);
    keys.forEach((key, i) => {
      this.textValChanged(values[i], key);
    });
    const result = [];
    keys.forEach((key, i) => (result[key] = values[i]));
    this.ngModelval = result;
    //this.fadeFastFadeOptions();
    this.ngModelval["FadeTime"] = result["FadeTime"];
    //this.FadeTime = result["FadeTime"];
  //this.onChangeList(result["FadeTime"]);
        const fastFadeTimeDefault = this.properties["FastFadeTime"]?.["default"] !== undefined ? this.properties["FastFadeTime"]["default"] : this.properties["FastFadeTime"]?.["const"];
        this.ngModelval["FastFadeTime"] = result["FastFadeTime"] !== undefined ? result["FastFadeTime"] : fastFadeTimeDefault;
        //this.FastFadeTime = result["FastFadeTime"];
        //this.onChangeFastFadeTimeList(result["FastFadeTime"]);
        this.ngModelval["FallbackDetectionTime"] =
        result["FallbackDetectionTime"];
        this.FallbackDetectionTimeValue = result["FallbackDetectionTime"];
        this.FallbackDetectionTimeDisplayValue = result["FallbackDetectionTime"];
        this.ngModelval["PowerOnLevel"] = result["PowerOnLevel"];
        this.PowerOnLevelValue =  result["PowerOnLevel"];
        this.PowerOnLevelDisplayValue = result["PowerOnLevel"];
        this.ngModelval["FallbackScene"] = result["FallbackScene"];
        this.FallbackSceneValue =  result["FallbackScene"];
      if(this.FallbackSceneValue === this.field.oneOf[1].properties.FallbackScene.const){
        this.ngModelval["ischeckboxChecked"] = this.ischeckboxChecked = true;
        this.changedVal(this.ischeckboxChecked);
        this.ngModelval["FallbackScene"] = this.FallbackScene.default;
        this.FallbackSceneValue =  this.FallbackScene.default;
      }
        this.ngModelval["Scene1"] = result["Scene1"];
        this.Scene1Value = result["Scene1"];
        this.ngModelval["Scene2"] = result["Scene2"];
        this.Scene2Value = result["Scene2"];
        this.ngModelval["Scene3"] = result["Scene3"];
        this.Scene3Value = result["Scene3"];
        this.ngModelval["Scene4"] = result["Scene4"];
        this.Scene4Value = result["Scene4"];
        this.ngModelval["Scene5"] = result["Scene5"];
        this.Scene5Value = result["Scene5"];
        this.ngModelval["Scene6"] = result["Scene6"];
        this.Scene6Value = result["Scene6"];
        this.ngModelval["Scene7"] = result["Scene7"];
        this.Scene7Value = result["Scene7"];
        this.ngModelval["Scene8"] = result["Scene8"];
        this.Scene8Value = result["Scene8"];
        this.ngModelval["Scene9"] = result["Scene9"];
        this.Scene9Value = result["Scene9"];
        this.ngModelval["Scene10"] = result["Scene10"];
        this.Scene10Value = result["Scene10"];
        this.ngModelval["Scene11"] = result["Scene11"];
        this.Scene11Value = result["Scene11"];
        this.ngModelval["Scene12"] = result["Scene12"];
        this.Scene12Value = result["Scene12"];
    this.validateSceneValues();
    this.checkdfault();
    this.checkInvalidValues();
    this.sendcodedmainsdata();
  }

  validateSceneValues() {
    for (let i = 1; i <= 12; i++) {
      const sceneKey = "Scene" + i;
      const min = this[sceneKey + "Min"];
      const max = this[sceneKey + "Max"];
      if (min === undefined || max === undefined) {
        continue;
      }
      const val = this.ngModelval[sceneKey];
      const value = Number(val);
      if (val === "" || val === undefined || val === null) {
        this.inputError[sceneKey] = true;
      } else if (value > max || value < min) {
        this.inputError[sceneKey] = true;
      } else {
        this.inputError[sceneKey] = false;
      }
    }
  }
  powerOnLevelOptionValueChange(value) {
    if (value >= this.PowerOnLevelMin && value <= this.PowerOnLevelMax) {
      this.ngModelval["PowerOnLevel"] = value;
      this.PowerOnLevelDisplayValue = value;
      this.inputError["PowerOnLevel"] = false;
      this.PowerOnLevelOption = {
        floor: this.PowerOnLevelMin,
        ceil: this.PowerOnLevelMax,
      };
      this.checkInvalidValues();
      this.sendcodedmainsdata();
      this.ref.detectChanges();
    } else {
      this.inputError["PowerOnLevel"] = true;
      this.codedmainsCreateFile = true;
    }
  }
  scene1ValChanged(val) {
    const value = Number(val);
    
    if (val === "" || val.length === 0) {
      this.inputError["Scene1"] = true;
      this.ngModelval["Scene1"] = this.Scene1Value = val;
    } else if (value > this.Scene1Max || value < this.Scene1Min) {
      this.inputError["Scene1"] = true;
      this.ngModelval["Scene1"] = this.Scene1Value = value;
    } else {
      this.ngModelval["Scene1"] = this.Scene1Value = value;
      this.inputError["Scene1"] = false;
    }
    this.checkInvalidValues();
    this.ref.markForCheck();
    setTimeout(() => {
      this.checkdfault();
      this.sendcodedmainsdata();
    }, 500);
  }
  scene2ValChanged(val) {
    const value = Number(val);
    
    if (val === "" || val.length === 0) {
      this.inputError["Scene2"] = true;
      this.ngModelval["Scene2"] = this.Scene2Value = val;
    } else if (value > this.Scene2Max || value < this.Scene2Min) {
      this.inputError["Scene2"] = true;
      this.ngModelval["Scene2"] = this.Scene2Value = value;
    } else {
      this.ngModelval["Scene2"] = this.Scene2Value = value;
      this.inputError["Scene2"] = false;
    }
    this.checkInvalidValues();
    this.ref.markForCheck();
    setTimeout(() => {
      this.checkdfault();
      this.sendcodedmainsdata();
    }, 500);
  }
  scene3ValChanged(val) {
    const value = Number(val);
    
    if (val === "" || val.length === 0) {
      this.inputError["Scene3"] = true;
      this.ngModelval["Scene3"] = this.Scene3Value = val;
    } else if (value > this.Scene3Max || value < this.Scene3Min) {
      this.inputError["Scene3"] = true;
      this.ngModelval["Scene3"] = this.Scene3Value = value;
    } else {
      this.ngModelval["Scene3"] = this.Scene3Value = value;
      this.inputError["Scene3"] = false;
    }
    this.checkInvalidValues();
    this.ref.markForCheck();
    setTimeout(() => {
      this.checkdfault();
      this.sendcodedmainsdata();
    }, 500);
  }
  scene4ValChanged(val) {
    const value = Number(val);
    
    if (val === "" || val.length === 0) {
      this.inputError["Scene4"] = true;
      this.ngModelval["Scene4"] = this.Scene4Value = val;
    } else if (value > this.Scene4Max || value < this.Scene4Min) {
      this.inputError["Scene4"] = true;
      this.ngModelval["Scene4"] = this.Scene4Value = value;
    } else {
      this.ngModelval["Scene4"] = this.Scene4Value = value;
      this.inputError["Scene4"] = false;
    }
    this.checkInvalidValues();
    this.ref.markForCheck();
    setTimeout(() => {
      this.checkdfault();
      this.sendcodedmainsdata();
    }, 500);
  }
  scene5ValChanged(val) {
    const value = Number(val);
    
    if (val === "" || val.length === 0) {
      this.inputError["Scene5"] = true;
      this.ngModelval["Scene5"] = this.Scene5Value = val;
    } else if (value > this.Scene5Max || value < this.Scene5Min) {
      this.inputError["Scene5"] = true;
      this.ngModelval["Scene5"] = this.Scene5Value = value;
    } else {
      this.ngModelval["Scene5"] = this.Scene5Value = value;
      this.inputError["Scene5"] = false;
    }
    this.checkInvalidValues();
    this.ref.markForCheck();
    setTimeout(() => {
      this.checkdfault();
      this.sendcodedmainsdata();
    }, 500);
  }
  scene6ValChanged(val) {
    const value = Number(val);
    
    if (val === "" || val.length === 0) {
      this.inputError["Scene6"] = true;
      this.ngModelval["Scene6"] = this.Scene6Value = val;
    } else if (value > this.Scene6Max || value < this.Scene6Min) {
      this.inputError["Scene6"] = true;
      this.ngModelval["Scene6"] = this.Scene6Value = value;
    } else {
      this.ngModelval["Scene6"] = this.Scene6Value = value;
      this.inputError["Scene6"] = false;
    }
    this.checkInvalidValues();
    this.ref.markForCheck();
    setTimeout(() => {
      this.checkdfault();
      this.sendcodedmainsdata();
    }, 500);
  }
  scene7ValChanged(val) {
    const value = Number(val);
    
    if (val === "" || val.length === 0) {
      this.inputError["Scene7"] = true;
      this.ngModelval["Scene7"] = this.Scene7Value = val;
    } else if (value > this.Scene7Max || value < this.Scene7Min) {
      this.inputError["Scene7"] = true;
      this.ngModelval["Scene7"] = this.Scene7Value = value;
    } else {
      this.ngModelval["Scene7"] = this.Scene7Value = value;
      this.inputError["Scene7"] = false;
    }
    this.checkInvalidValues();
    this.ref.markForCheck();
    setTimeout(() => {
      this.checkdfault();
      this.sendcodedmainsdata();
    }, 500);
  }
  scene8ValChanged(val) {
    const value = Number(val);
    
    if (val === "" || val.length === 0) {
      this.inputError["Scene8"] = true;
      this.ngModelval["Scene8"] = this.Scene8Value = val;
    } else if (value > this.Scene8Max || value < this.Scene8Min) {
      this.inputError["Scene8"] = true;
      this.ngModelval["Scene8"] = this.Scene8Value = value;
    } else {
      this.ngModelval["Scene8"] = this.Scene8Value = value;
      this.inputError["Scene8"] = false;
    }
    this.checkInvalidValues();
    this.ref.markForCheck();
    setTimeout(() => {
      this.checkdfault();
      this.sendcodedmainsdata();
    }, 500);
  }
  scene9ValChanged(val) {
    const value = Number(val);
    
    if (val === "" || val.length === 0) {
      this.inputError["Scene9"] = true;
      this.ngModelval["Scene9"] = this.Scene9Value = val;
    } else if (value > this.Scene9Max || value < this.Scene9Min) {
      this.inputError["Scene9"] = true;
      this.ngModelval["Scene9"] = this.Scene9Value = value;
    } else {
      this.ngModelval["Scene9"] = this.Scene9Value = value;
      this.inputError["Scene9"] = false;
    }
    this.checkInvalidValues();
    this.ref.markForCheck();
    setTimeout(() => {
      this.checkdfault();
      this.sendcodedmainsdata();
    }, 500);
  }
  scene10ValChanged(val) {
    const value = Number(val);
    
    if (val === "" || val.length === 0) {
      this.inputError["Scene10"] = true;
      this.ngModelval["Scene10"] = this.Scene10Value = val;
    } else if (value > this.Scene10Max || value < this.Scene10Min) {
      this.inputError["Scene10"] = true;
      this.ngModelval["Scene10"] = this.Scene10Value = value;
    } else {
      this.ngModelval["Scene10"] = this.Scene10Value = value;
      this.inputError["Scene10"] = false;
    }
    this.checkInvalidValues();
    this.ref.markForCheck();
    setTimeout(() => {
      this.checkdfault();
      this.sendcodedmainsdata();
    }, 500);
  }
  scene11ValChanged(val) {
    const value = Number(val);
    
    if (val === "" || val.length === 0) {
      this.inputError["Scene11"] = true;
      this.ngModelval["Scene11"] = this.Scene11Value = val;
    } else if (value > this.Scene11Max || value < this.Scene11Min) {
      this.inputError["Scene11"] = true;
      this.ngModelval["Scene11"] = this.Scene11Value = value;
    } else {
      this.ngModelval["Scene11"] = this.Scene11Value = value;
      this.inputError["Scene11"] = false;
    }
    this.checkInvalidValues();
    this.ref.markForCheck();
    setTimeout(() => {
      this.checkdfault();
      this.sendcodedmainsdata();
    }, 500);
  }
  scene12ValChanged(val) {
    const value = Number(val);
    
    if (val === "" || val.length === 0) {
      this.inputError["Scene12"] = true;
      this.ngModelval["Scene12"] = this.Scene12Value = val;
    } else if (value > this.Scene12Max || value < this.Scene12Min) {
      this.inputError["Scene12"] = true;
      this.ngModelval["Scene12"] = this.Scene12Value = value;
    } else {
      this.ngModelval["Scene12"] = this.Scene12Value = value;
      this.inputError["Scene12"] = false;
    }
    this.checkInvalidValues();
    this.ref.markForCheck();
    setTimeout(() => {
      this.checkdfault();
      this.sendcodedmainsdata();
    }, 500);
  }
  fallbackDetectionTimeValueChange(value) {
    if (
      value >= this.FallbackDetectionTimeMin &&
      value <= this.FallbackDetectionTimeMax
    ) {
      this.ngModelval["FallbackDetectionTime"] = value;
      this.FallbackDetectionTimeDisplayValue = value;
      this.inputError["FallbackDetectionTime"] = false;
      this.FallbackDetectionTimeOption = {
        floor: this.FallbackDetectionTimeMin,
        ceil: this.FallbackDetectionTimeMax,
      };
      this.checkInvalidValues();
      this.sendcodedmainsdata();
      this.ref.detectChanges();
    } else {
      this.inputError["FallbackDetectionTime"] = true;
      this.codedmainsCreateFile = true;
    }
  }
  onChangeList(value) {
    const newValue = Number(value);
    if (newValue !== 0) {
      this.isFastFadeTimeEnabled = true;
    } else {
      this.isFastFadeTimeEnabled = false;
    }
    this.fadeTimeDynamicVal = this.fadeTimeDataset[value];
    this.ngModelval["FadeTime"] = newValue;
    this.sendcodedmainsdata();
    this.checkdfault();
    this.checkInvalidValues();
  }
  onChangeFastFadeTimeList(value) {
    const newValue = Number(value);
    this.fastfadeTimeDynamicVal = this.fastfadeTimeDataset[value];
    this.ngModelval["FastFadeTime"] = newValue;
    this.sendcodedmainsdata();
    this.checkdfault();
    this.checkInvalidValues();
  }

  onFieldInput(value: string, fieldName: string) {
    if (fieldName === 'FallbackDetectionTime') {
      this.FallbackDetectionTimeDisplayValue = value;
      this.fallbackDetectionTimeInputSubject.next(value);
    } else if (fieldName === 'PowerOnLevel') {
      this.PowerOnLevelDisplayValue = value;
      this.powerOnLevelInputSubject.next(value);
    }
    this.ref.detectChanges();
  }

  onFieldBlur(fieldName: string) {
    let value: string;
    if (fieldName === 'FallbackDetectionTime') {
      value = this.FallbackDetectionTimeDisplayValue;
    } else if (fieldName === 'PowerOnLevel') {
      value = this.PowerOnLevelDisplayValue;
    }
    this.validateAndUpdateField(value, fieldName);
  }

  validateAndUpdateField(value: string, colName: string) {
    let numValue = parseFloat(value);

    if (isNaN(numValue) || value === '' || value === null || value === undefined) {
      this.inputError[colName] = true;
      this.codedmainsCreateFile = true;

      if (colName === 'FallbackDetectionTime') {
        this.FallbackDetectionTimeDisplayValue = value;
        this.ngModelval['FallbackDetectionTime'] = this.FallbackDetectionTimeMin;
        this.FallbackDetectionTimeValue = this.FallbackDetectionTimeMin;
      } else if (colName === 'PowerOnLevel') {
        this.PowerOnLevelDisplayValue = value;
        this.ngModelval['PowerOnLevel'] = this.PowerOnLevelMin;
        this.PowerOnLevelValue = this.PowerOnLevelMin;
      }

      this.service.codedmainsInputError(this.codedmainsCreateFile);
      this.codedmainsDefaultColor = false;
      this.service.codedmainsEditedVal(this.codedmainsDefaultColor);
      this.ref.detectChanges();
      return;
    }

    numValue = parseInt(value);
    this.codedmainsDefaultColor = false;
    this.inputError[colName] = false;
    this.codedmainsCreateFile = false;

    if (colName === 'FallbackDetectionTime') {
      if (numValue < this.FallbackDetectionTimeMin || numValue > this.FallbackDetectionTimeMax) {

        this.inputError[colName] = true;
        this.FallbackDetectionTimeDisplayValue = value;


        let clampedValue;
        if (numValue < this.FallbackDetectionTimeMin) {
          clampedValue = this.FallbackDetectionTimeMin;
        } else if (numValue > this.FallbackDetectionTimeMax) {
          clampedValue = this.FallbackDetectionTimeMax;
        }
        this.ngModelval['FallbackDetectionTime'] = clampedValue;
        this.FallbackDetectionTimeValue = clampedValue;
      } else {

        this.FallbackDetectionTimeValue = numValue;
        this.ngModelval['FallbackDetectionTime'] = numValue;
        this.FallbackDetectionTimeDisplayValue = numValue;
        this.inputError[colName] = false;
      }
    } else if (colName === 'PowerOnLevel') {

      if (numValue < this.PowerOnLevelMin || numValue > this.PowerOnLevelMax) {

        this.inputError[colName] = true;
        this.PowerOnLevelDisplayValue = value;


        let clampedValue;
        if (numValue < this.PowerOnLevelMin) {
          clampedValue = this.PowerOnLevelMin;
        } else if (numValue > this.PowerOnLevelMax) {
          clampedValue = this.PowerOnLevelMax;
        }
        this.ngModelval['PowerOnLevel'] = clampedValue;
        this.PowerOnLevelValue = clampedValue;
      } else {

        this.PowerOnLevelValue = numValue;
        this.ngModelval['PowerOnLevel'] = numValue;
        this.PowerOnLevelDisplayValue = numValue;
        this.inputError[colName] = false;
      }
    }

    this.checkdfault();
    for (const type in this.inputError) {
      if (this.inputError[type]) {
        this.codedmainsCreateFile = true;
      }
    }
    this.service.codedmainsEditedVal(this.codedmainsDefaultColor);
    this.service.codedmainsInputError(this.codedmainsCreateFile);
    this.sendcodedmainsdata();
    this.ref.detectChanges();
  }

  textValChanged(value, colName) {
    const val = value;
    value = parseInt(value);
    if (isNaN(value) || value.length === 0) {
      value = 0;
    }
    this.codedmainsDefaultColor = false;
    this.inputError[colName] = false;
    this.codedmainsCreateFile = false;
    if (colName == "FallbackDetectionTime") {
      if (
        value < this.FallbackDetectionTimeMin ||
        value > this.FallbackDetectionTimeMax
      ) {
        this.inputError[colName] = true;
        this.ngModelval["FallbackDetectionTime"] = value;
      } else {
        this.FallbackDetectionTimeValue = value;
        this.ngModelval["FallbackDetectionTime"] = value;
      }
    } else if (colName == "PowerOnLevel") {
      if (val.length === 0) {
        this.inputError[colName] = true;
        this.ngModelval["PowerOnLevel"] = val;
      } else if (value < this.PowerOnLevelMin || value > this.PowerOnLevelMax) {
        this.inputError[colName] = true;
        this.ngModelval["PowerOnLevel"] = value;
      } else {
        this.PowerOnLevelValue = value;
        this.ngModelval["PowerOnLevel"] = value;
      }
    } else if (colName == "FallbackScene") {
      if (val.length === 0) {
        this.inputError[colName] = true;
        this.ngModelval["FallbackScene"] = val;
      } else if (
        (value < this.FallbackSceneMin ||
        value > this.FallbackSceneMax) && (value != 255)
      ) {
        this.inputError[colName] = true;
        this.ngModelval["FallbackScene"] = value;
      } else {
        this.FallbackSceneValue = value;
        this.ngModelval["FallbackScene"] = value;
      }
    }
    this.checkdfault();
    for (const type in this.inputError) {
      if (this.inputError[type]) {
        this.codedmainsCreateFile = true;
      }
    }
    this.service.codedmainsEditedVal(this.codedmainsDefaultColor);
    this.service.codedmainsInputError(this.codedmainsCreateFile);
    this.sendcodedmainsdata();
  }
  isFeatureEnabled(value) {
    if (value === true) {
      this.service.setcodedmainsDefaultColor(this.codedmainsDefaultColor);
      this.ngModelval["CodedMainsEnabled"] = value;
      this.sendcodedmainsdata();
    } else if (value === false) {
      this.service.setcodedmainsDefaultColor(this.codedmainsDefaultColor);
      this.ngModelval["CodedMainsEnabled"] = value;
      this.sendcodedmainsdata();
    }
  }
  changedVal(value) {
    this.ngModelval["ischeckboxChecked"] = this.ischeckboxChecked = value;
    this.codedmainsDefaultColor = value;
    this.isLastDefinedDimLevelEnabled = value;
    this.checkdfault();
    this.service.setcodedmainsDefaultColor(this.codedmainsDefaultColor);
    this.sendcodedmainsdata();
  }
  checkInvalidValues() {
    this.codedmainsCreateFile = false;
    for (const type in this.inputError) {
      if (this.inputError[type]) {
        this.codedmainsCreateFile = true;
      }
    }
    this.service.codedmainsInputError(this.codedmainsCreateFile);
  }
  resetDefaultcodedmains() {
    this.ngModelval["ischeckboxChecked"] =
      this.ischeckboxChecked =
      this.isLastDefinedDimLevelEnabled =
        false;
    this.ngModelval["FadeTime"] = this.FadeTime.default;
    this.fadeTimeDynamicVal = this.fadeTimeDataset[this.FadeTime.default];
    if (this.FadeTime.default != 0) {
      this.isFastFadeTimeEnabled = true;
    } else {
      this.isFastFadeTimeEnabled = false;
    }
    const fastFadeTimeDefault = this.FastFadeTime.default !== undefined ? this.FastFadeTime.default : this.FastFadeTime.const;
    this.ngModelval["FastFadeTime"] = fastFadeTimeDefault;
    this.fastfadeTimeDynamicVal =
      this.fastfadeTimeDataset[fastFadeTimeDefault];
    this.ngModelval["FallbackDetectionTime"] = this.FallbackDetectionTimeValue =
      this.FallbackDetectionTime.default;
    this.FallbackDetectionTimeDisplayValue = this.FallbackDetectionTime.default;
    this.ngModelval["PowerOnLevel"] = this.PowerOnLevelValue =
      this.PowerOnLevel.default;
    this.PowerOnLevelDisplayValue = this.PowerOnLevel.default;
    this.ngModelval["FallbackScene"] = this.FallbackSceneValue =
      this.FallbackScene.default;
    this.ngModelval["Scene12"] = this.Scene12Value = this.Scene12.default;
    this.ngModelval["Scene11"] = this.Scene11Value = this.Scene11.default;
    this.ngModelval["Scene10"] = this.Scene10Value = this.Scene10.default;
    this.ngModelval["Scene9"] = this.Scene9Value = this.Scene9.default;
    this.ngModelval["Scene8"] = this.Scene8Value = this.Scene8.default;
    this.ngModelval["Scene7"] = this.Scene7Value = this.Scene7.default;
    this.ngModelval["Scene6"] = this.Scene6Value = this.Scene6.default;
    this.ngModelval["Scene5"] = this.Scene5Value = this.Scene5.default;
    this.ngModelval["Scene4"] = this.Scene4Value = this.Scene4.default;
    this.ngModelval["Scene3"] = this.Scene3Value = this.Scene3.default;
    this.ngModelval["Scene2"] = this.Scene2Value = this.Scene2.default;
    this.ngModelval["Scene1"] = this.Scene1Value = this.Scene1.default;
    for (const type in this.inputError) {
      this.inputError[type] = false;
    }
    this.codedmainsCreateFile = false;
    this.service.codedmainsInputError(this.codedmainsCreateFile);
    this.sendcodedmainsdata();
    this.ref.markForCheck();
  }
  sliderEvent(option1?) {}
  
  private isValueChanged(type: string): boolean {
    const expectedValue = this.properties[type]["default"] !== undefined
      ? this.properties[type]["default"]
      : this.properties[type]["const"];
    return this.ngModelval[type] !== expectedValue || this.ngModelval["ischeckboxChecked"] === true;
  }

  checkdfault() {
    this.codedmainsDefaultColor = true;

    for (const type in this.inputError) {
      if (this.inputError[type] && (!this.column || this.column.includes(type))) {
        this.codedmainsDefaultColor = false;
        this.service.codedmainsEditedVal(this.codedmainsDefaultColor);
        return;
      }
    }

    const fieldsToCheck = [
      "FadeTime", "FastFadeTime", "FallbackDetectionTime", "PowerOnLevel",
      "FallbackScene", "Scene1", "Scene2", "Scene3", "Scene4", "Scene5",
      "Scene6", "Scene7", "Scene8", "Scene9", "Scene10", "Scene11", "Scene12"
    ];

    for (const type in this.ngModelval) {
      if (fieldsToCheck.includes(type) && this.isValueChanged(type)) {
        this.codedmainsDefaultColor = false;
      }
      this.service.codedmainsEditedVal(this.codedmainsDefaultColor);
    }
  }
  ngOnDestroy() {
    this.service.setcodedmainsDefaultColor("");
    this.service.sendcodedmainsdata("");
  }
}

